const messageHandlers = []

const listener = event => {
  const { data } = event

  if (!Array.isArray(data)) return

  const [type, payload] = data

  messageHandlers.forEach(({ type: MHType, handler }, index) => {
    if (type === MHType) handler(payload)
  })
}

export const init = () => {
  // clean listeners to avoid duplicates
  window.removeEventListener('message', listener)
  window.addEventListener('message', listener)
}

export const subscribe = (type, handler) => messageHandlers.push({ type, handler })
